module.exports = __webpack_public_path__ + "img/bay.78f13504.svg";